import { DashboardAccess, NativeDashboardRecord, ViewerRule } from "./types";

export const filterPageDashboards = (records: Array<NativeDashboardRecord>, registryKeys: Array<string>) => {
    const pageDashboards = records
        .filter((record) => record.status === "published")
        .filter((record) => registryKeys.includes(record.key))
        .sort((firstRecord, secondRecord) => (firstRecord.sort || 0) - (secondRecord.sort || 0));
    return pageDashboards;
};

export const canSeeDashboard = (records: Array<NativeDashboardRecord>, dashboardKey: string) => {
    const hasRecord = records.some((record) => record.key === dashboardKey && record.status === "published");
    return hasRecord;
};

// users/me devolve o role expandido, mas degrada para uuid cru quando o role não lê directus_roles.
export const normalizeRoleId = (role: { id?: string } | string | null | undefined) => {
    if (!role) return null;
    if (typeof role === "string") return role;
    const roleId = role.id || null;
    return roleId;
};

type ResolvedViewerRule = {
    viewerParams: Record<string, string | number> | null;
    viewerRuleMissing: boolean;
};

export const resolveViewerRule = (rules: Array<ViewerRule> | null | undefined, viewerRoleId: string | null): ResolvedViewerRule => {
    const noRestriction: ResolvedViewerRule = { viewerParams: {}, viewerRuleMissing: false };
    if (!rules || rules.length === 0) return noRestriction;

    const matchedRule = rules.find((rule) => {
        if (!rule.roles) return true;
        const roleMatches = viewerRoleId !== null && rule.roles.includes(viewerRoleId);
        return roleMatches;
    });

    if (!matchedRule) {
        const failClosed: ResolvedViewerRule = { viewerParams: null, viewerRuleMissing: true };
        return failClosed;
    }

    const resolved: ResolvedViewerRule = { viewerParams: matchedRule.params || {}, viewerRuleMissing: false };
    return resolved;
};

// drill_roles vazio ou ausente = ninguém tem drill (decisão explícita, fail-closed).
export const canDrillDashboard = (record: NativeDashboardRecord, viewerRoleId: string | null) => {
    if (!viewerRoleId) return false;
    const drillRoleIds = (record.drill_roles || [])
        .map((junctionRow) => junctionRow.directus_roles_id)
        .filter((roleId): roleId is string => Boolean(roleId));
    const isAllowed = drillRoleIds.includes(viewerRoleId);
    return isAllowed;
};

// Transporte por query: extensão SÓ quando a row é global E o spec declara semântica global.
// Specs "viewer" num dashboard global continuam a ir por /items com o token do utilizador.
export const resolveQueryTransport = (accessTransport: "viewer" | "extension", specDataScope: "viewer" | "global") => {
    const transport = accessTransport === "extension" && specDataScope === "global" ? "extension" : "viewer";
    return transport;
};

// Parte da queryKey que distingue transportes: respostas da extensão são por dashboard (URL própria),
// respostas viewer continuam partilhadas entre dashboards (dedupe das métricas partilhadas).
export const transportQueryKey = (transport: "viewer" | "extension", dashboardKey: string) => {
    const keyPart = transport === "extension" ? `extension:${dashboardKey}` : "viewer";
    return keyPart;
};

export const buildDashboardAccess = (record: NativeDashboardRecord, viewerRoleId: string | null): DashboardAccess => {
    const dataScope = record.data_scope === "global" ? "global" : "user";
    const { viewerParams, viewerRuleMissing } = resolveViewerRule(record.viewer_rules, viewerRoleId);
    const access: DashboardAccess = {
        dashboardKey: record.key,
        dataScope,
        transport: dataScope === "global" ? "extension" : "viewer",
        canDrill: canDrillDashboard(record, viewerRoleId),
        viewerParams,
        viewerRuleMissing,
    };
    return access;
};
